import { useEffect } from "react";

export const useScrollDocument = (scrollTo = 0): void => {
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = scrollTo;
  }, [scrollTo]);
};
